<template>
  <div>
        <el-drawer :modal="false" 
        :visible.sync="drawerPayoutSummaries"
        class="drawer-view-payout-summaries"
        size="60%"
        >
            <div slot="title">
                <b-row align-h="between" align-v="center">
                    <b-col cols="12" md="4" class="d-flex align-items-center mb-3 mb-md-0">
                        <div class="demo-basic--circle me-2">
                            <el-avatar></el-avatar>
                        </div>
                        <h3 class="mb-0 mx-3 text-truncate">{{ member_name }}</h3>
                        <!-- <el-select v-model="datePicked" 
                            placeholder="Select" 
                            style="width: 120px; min-width: 120px;"
                        >
                            <el-option
                            v-for="item in dateOptions"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                            </el-option>
                        </el-select> -->
                    </b-col>
                    <b-col cols="12" md="5" class="d-flex align-items-center justify-content-end">
                        <div class="mx-3 name text-primary mb-0 cursor-pointer" @click="toggleClawbackModal()">
                            Clawback
                        </div>
                        <div class="mx-3 name text-primary mb-0 cursor-pointer"  @click="togglePayslipHistoryModal()">
                            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1c-2.73 2.71-2.73 7.08 0 9.79s7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29c-3.51 3.48-9.21 3.48-12.72 0c-3.5-3.47-3.53-9.11-.02-12.58s9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08l-.72 1.21L11 13V8h1.5z"/></svg>
                            Payslip History
                        </div>
                        <b-button variant="primary" @click="toggleResendPaySlipModal()">
                            Resend Payslip
                        </b-button>
                    </b-col>
                </b-row>
            </div>

            <b-container>
                <CommisionReleaseSummaryListing :tableData="tableData"/>
            </b-container>

        </el-drawer>
        <ClawbackModal :clawback.sync="modals.clawback" modalClasses="drawer-view-clawback" />
        <PayslipHistoryModal :payslip_history.sync="modals.payslip_history" modalClasses="drawer-view-clawback" />
        <ResendPayslipModal :resend_payslip.sync="modals.resend_payslip" modalClasses="drawer-view-clawback" />
  </div>
</template>
<script>
import { Drawer, Avatar, Button, RadioGroup, RadioButton, Checkbox, Collapse, CollapseItem, Form, FormItem, Select, Option, Dropdown, DropdownMenu, DropdownItem  } from 'element-ui'
import {
notifyFunctionMixin,
helperFunctionMixin,
axios,
services,
getHeader,
} from '@/assets/js/httpImports.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import '@/assets/js/formValidations.js'
import CommisionReleaseSummaryListing from '@/views/Commission/Payout/PayoutSummaries/Tables/CommisionReleaseSummaryListing.vue'
import PendingCommissionSummaryListing from '@/views/Commission/Payout/PayoutSummaries/Tables/PendingCommissionSummaryListing.vue'
import ClawbackModal from '@/views/Commission/Payout/PayoutSummaries/Modals/ClawbackModal.vue'
import PayslipHistoryModal from '@/views/Commission/Payout/PayoutSummaries/Modals/PayslipHistoryModal.vue'
import ResendPayslipModal from '@/views/Commission/Payout/PayoutSummaries/Modals/ResendPayslipModal.vue'

export default {
  name: 'drawer-view-payout-summaries',
  components: {
        CommisionReleaseSummaryListing,
        PendingCommissionSummaryListing,
        ClawbackModal,
        PayslipHistoryModal,
        ResendPayslipModal,
        ValidationObserver,
        ValidationProvider,
        [Drawer.name]: Drawer,
        [Button.name]: Button,
        [RadioGroup.name]: RadioGroup,
        [RadioButton.name]: RadioButton,
        [Checkbox.name]: Checkbox,
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem,
        [Form.name]: Form,
        [FormItem.name]: FormItem,
        [Select.name]: Select,
        [Option.name]: Option,
        [Avatar.name]: Avatar,
        [Dropdown.name]: Dropdown,
        [DropdownMenu.name]: DropdownMenu,
        [DropdownItem.name]: DropdownItem,
  },
  mixins:[
      helperFunctionMixin,
      notifyFunctionMixin
  ],
  data() {
      return {
        modals: {
            clawback: false,
            payslip_history: false,
            resend_payslip: false,
        },
        drawerPayoutSummaries: false,
        dateOptions: [
            {
                value: 'Dec 2023',
                label: 'Dec 2023'
            },
            {
                value: 'Nov 2023',
                label: 'Nov 2023'
            },
            {
                value: 'Oct 2023',
                label: 'Oct 2023'
            },
        ],
        datePicked: 'Dec 2023',
        tableData: [],
        member_name: null,
      };
  },
  methods: {
      viewDetails(row) {
          this.drawerPayoutSummaries = !this.drawerPayoutSummaries;
          this.getPayoutDetails(row);
          this.member_name = row.user.name;
      },
      toggleClawbackModal(){
        this.modals.clawback = !this.modals.clawback
      },
      togglePayslipHistoryModal(){
        this.modals.payslip_history = !this.modals.payslip_history
      },
      toggleResendPaySlipModal(){
        this.modals.resend_payslip = !this.modals.resend_payslip
      },
      getPayoutDetails(row) {
        let params = "";
        if(row.date_month && row.date_year)
        {
            params = "?month="+row.date_month+'&year='+row.date_year;
        }
        axios.get(services.hub + 'hub_comms/direct_payout_detail.show_payout_details_by_user_id/' + row.user.id + params, {headers: getHeader()})
        .then(res  => {
            this.tableData = res.data.data;
        })
        .catch(e => {
            this.errorFunction(e)
        })
      },

  }
}
</script>